/* istanbul ignore file */
export default
`<div class="layout-container" :class="containerClasses" :style="containerStyles">
    <div class="header-content" :class="headerClasses" :style="headerStyles" ref="headerContent" v-if="settings.enableHeader">
        <div class="header-top-row">
            <div class="header-logo" v-if="settings.headerLogoImage">
                <img :src="settings.headerLogoImage" :style="headerLogoStyles" :alt="settings.headerLogoAltText" :title="settings.headerLogoTitle"/>
            </div>
            <div class="header-text">
                <component :is="{template: '<div>' + settings.header + '</div>', props:{user: {default: false}}}" :user="user" />
            </div>
            <div class="header-components">
                <div v-if="positionsFiltered[0]" v-for="(component, index) in positionsFiltered[0].components" :key="component.cId" style="height: 100%; width: 100%">
                    <component 
                        v-bind="componentMappedProps[component.cId]" 
                        :is="component.cType" 
                        :cId="component.cId"
                        :editor-enabled="editorEnabled"
                        v-if="displayedComponents[component.cId]" 
                        v-show="showedComponents[component.cId]" 
                        :unique-store-id="uniqueStoreId"
                        class="layout-component"
                        :ref="'ref__' + component.cId"
                    ></component>
                </div>
            </div>
        </div>
        <p v-if="settings.headerMessage">{{settings.headerMessage}}</p>
    </div>
    <div class="layout-content" ref="layoutContent">
        <ejs-splitter :id="'mainSplitter_' + templateUniqueId" separatorSize="3" ref="splitter">
            <e-panes>
                <e-pane :content="'#leftColumn_' + templateUniqueId" size="25%" :collapsible="splitterCollapsible"  :collapsed="pane0Collapsed"></e-pane>
                <e-pane :content="'#rightColumn_' + templateUniqueId" :collapsible="splitterCollapsible"  :collapsed="pane1Collapsed"></e-pane>
            </e-panes>
        </ejs-splitter>
        <div :id="'leftColumn_' + templateUniqueId" style="height: 100%; position: relative;" :class="splitPaneClasses.leftColumn">
            <button type="button" class="expand-collapse-button collapse-left" :class="expandCollapseButtonClasses.left" @click="toggleSplitter(1)" :title="pane1Collapsed ? 'Expand' : 'Collapse'"><span class="e-icons" :class="expandCollapseIcon.left"></span></button>
            <div v-if="!hideComponents.pane0 || (hideComponents.pane0 && !pane0Collapsed)" style="height: 100%;">
                <div v-if="positionsFiltered[1]" v-for="(component, index) in positionsFiltered[1].components" :key="component.cId" style="height: 100%; width: 100%">
                    <component 
                        v-bind="componentMappedProps[component.cId]" 
                        :is="component.cType" 
                        :cId="component.cId" 
                        :editor-enabled="editorEnabled"
                        v-if="displayedComponents[component.cId]" 
                        v-show="showedComponents[component.cId]" 
                        :unique-store-id="uniqueStoreId"
                        class="layout-component"
                        :ref="'ref__' + component.cId"
                    ></component>
                </div>
            </div>
        </div>
        <div :id="'rightColumn_' + templateUniqueId" style="height: 100%; position: relative;" :class="splitPaneClasses.rightColumn">
            <button type="button" class="expand-collapse-button collapse-right" @click="toggleSplitter(0)" :title="pane0Collapsed ? 'Expand' : 'Collapse'" :class="expandCollapseButtonClasses.right"><span class="e-icons" :class="expandCollapseIcon.right"></span></button>
            <div v-if="!hideComponents.pane1 || (hideComponents.pane1 && !pane1Collapsed)" style="height: 100%;">
                <div v-if="positionsFiltered[2]" v-for="(component, index) in positionsFiltered[2].components" :key="component.cId" style="height: 100%; width: 100%">
                    <component 
                        v-bind="componentMappedProps[component.cId]" 
                        :is="component.cType"
                        :cId="component.cId"
                        :editor-enabled="editorEnabled"
                        v-if="displayedComponents[component.cId]" 
                        v-show="showedComponents[component.cId]" 
                        :unique-store-id="uniqueStoreId"
                        class="layout-component"
                        :ref="'ref__' + component.cId"
                    ></component>
                </div>
            </div>
        </div>
        <div class="footer-content" ref="footerContent" v-if="settings.enableFooter">
            <div v-if="positionsFiltered[3]" v-for="(component, index) in positionsFiltered[3].components" :key="component.cId" style="height: 100%; width: 100%">
                <component 
                    v-bind="componentMappedProps[component.cId]" 
                    :is="component.cType" 
                    :cId="component.cId" 
                    :editor-enabled="editorEnabled"
                    v-if="displayedComponents[component.cId]" 
                    v-show="showedComponents[component.cId]" 
                    :unique-store-id="uniqueStoreId"
                    class="layout-component"
                    :ref="'ref__' + component.cId"
                ></component>
            </div>
        </div>
    </div>
</div>`;
